import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';
import { Navigate } from 'react-router-dom';

import { useStudioModel } from './StudioModelProvider.js';

export function StreamSessionGuard({ children }: { children: ReactElement }): ReactElement {
  const { isNavLocked, isLoading } = useStudioModel();

  if (isLoading) {
    return <p style={{ color: 'var(--fm-color-text-muted)' }}>{t('common.studio.dashboard.loading')}</p>;
  }

  if (isNavLocked) {
    return <Navigate to="/live" replace />;
  }

  return children;
}
